import React, { forwardRef } from "react";
import "./ButtonComponent.scss";

const cx = (...a) => a.filter(Boolean).join(" ");

const ButtonComponent = forwardRef(
  (
    {
      children,
      variant = "primary", // "primary" | "outline" | "ghost" | "link"
      size = "md", // "sm" | "md" | "lg"
      loading = false,
      disabled = false,
      className,
      leftIcon,
      rightIcon,
      as: Tag = "button",
      ...props
    },
    ref
  ) => {
    const isDisabled = disabled || loading;

    return (
      <Tag
        ref={ref}
        className={cx(
          "ui-btn",
          `ui-btn--${variant}`,
          `ui-btn--${size}`,
          isDisabled && "ui-btn--disabled",
          className
        )}
        disabled={Tag === "button" ? isDisabled : undefined}
        aria-disabled={Tag !== "button" && isDisabled ? "true" : undefined}
        {...props}
      >
        {loading && <span className="ui-btn__spinner" aria-hidden />}
        {leftIcon && (
          <span className="ui-btn__icon ui-btn__icon--left">{leftIcon}</span>
        )}
        <span className="ui-btn__label">{children}</span>
        {rightIcon && (
          <span className="ui-btn__icon ui-btn__icon--right">{rightIcon}</span>
        )}
      </Tag>
    );
  }
);

ButtonComponent.displayName = "ButtonComponent";

export default ButtonComponent;